import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function RequireAuth() {
  const { corp, loading } = useAuth();
  if (loading) return <div className="grid h-screen place-items-center">Loading…</div>;
  return corp ? <Outlet /> : <Navigate to="/" replace />;
}
